import { render } from "./App.vue?vue&type=template&id=aaee79ae"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=aaee79ae&lang=scss"

import exportComponent from "/Users/aks/Desktop/WORK/Codes/HCL Harit/chatbot-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__